@if ((activeStepIndex$ | async) !== undefined) {
  <div>
    @if (cart$ | async; as cart) {
      <div>
        <div class="cx-media">
          @for (step of steps$ | async; track step; let i = $index) {
            <div>
              @if (i < activeStepIndex) {
                <div class="cx-list-media {{ step.id }}">
                  <div>{{ step.name | cxTranslate }}</div>
                  <button class="btn btn-link" [routerLink]="{ cxRoute: step.routeName } | cxUrl">
                    <app-custom-icons [type]="iconType.PENCIL"></app-custom-icons>
                  </button>
                </div>
              }
              @if (i === activeStepIndex) {
                <div class="cx-list-media is-active">
                  <div>{{ step.name | cxTranslate }}</div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}